var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9997,
    cy: 16,
    r: 12.6667,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 2.66666C8.64033 2.66666 2.66699 8.64 2.66699 16C2.66699 23.36 8.64033 29.3333 16.0003 29.3333C23.3603 29.3333 29.3337 23.36 29.3337 16C29.3337 8.64 23.3603 2.66666 16.0003 2.66666ZM14.2936 20.5467C13.8536 21.2533 13.0803 21.68 12.2403 21.68H8.587C8.12033 21.68 7.82698 21.1733 8.06698 20.7733L15.547 7.96C15.7603 7.58667 16.2936 7.56 16.547 7.90666L18.627 10.6933C19.227 11.4933 19.267 12.5733 18.747 13.4267L14.2936 20.5467ZM23.4003 21.68L18.2804 21.68C17.8137 21.68 17.5203 21.1733 17.7603 20.76L20.3203 16.4933C20.5603 16.1067 21.1204 16.1067 21.3604 16.4933L23.9203 20.76C24.1603 21.16 23.867 21.68 23.4003 21.68Z",
    fill: "#E84142"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/AVAX.53544c7499cc39ef9683cc27fae544dc.svg";
export { ForwardRef as ReactComponent };